export default function tabSectionTriggers() {
  const isPresent = document.querySelector("[data-tab-section-trigger]");
  if (!isPresent) {
    return;
  }

  const triggers = document.querySelectorAll("[data-tab-section-trigger]");
  const targets = document.querySelectorAll("[data-tab-section-target]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const target = document.querySelector(
        `[data-tab-section-target="${trigger.dataset.tabSectionTrigger}"]`
      );

      triggers.forEach((tr) => {
        tr.classList.remove("active");
      });
      trigger.classList.add("active");

      targets.forEach((t) => {
        t.classList.add("hidden");
      });

      target.classList.remove("hidden");
    });
  });
}
